import styles from './styles.module.scss';

const SidebarFooter = ({ children }) => {
  return (
    <div className={styles.sidebarFooter}>
      {children}
    </div>
  );
};

export default SidebarFooter;
